<template>
    <div class="historyBox-content typeArea">
        <div class="prev" @click="move('prev')">
            <img src="@/assets/images/carousel-red-left.png" alt="">
        </div>
        <div class="swiper">
            <div class="swiper-wrapper" ref="swiperWrapper" :style="{left:left+'px'}">
                <div class="prev-split" :style="{'width':prevSplitWidth+'px'}"></div>
                <div v-for="(history,index) in historyList" :key="index" class="item" ref="historyItem">
                    <div class="circle-outer">
                        <div class="circle-inner"></div>
                    </div>
                    <div class="content" :class="((index%2)==1)?'contentOdd':''">
                        <div class="date">{{history.date}}</div>
                        <div class="title" v-for="item in history.title" :key="item">{{item}}</div>
                        <div class="sub-title" v-for="item in history.subtitle" :key="item">{{item}}</div>
                        <div class="certification">
                            <div class="cerName">{{history.certification.name}}</div>
                            <div class="imgBox" @mouseenter="hoverIndex = index" @mouseleave="hoverIndex = -1">
                                <el-image
                                    class="cerImg"
                                    :src="history.certification.src[0]" 
                                    :preview-src-list="history.certification.src">
                                </el-image>
                                <div class="mask" v-show = "hoverIndex==index">
                                    <img src="@/assets/images/viewBigImg.png" alt="">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="next" @click="move('next')">
            <img src="@/assets/images/carousel-red-right.png" alt="">
        </div>
    </div>
</template>

<script>
export default {
  name: 'demo',
  props:{
    historyList:{
        default: ()=>[],
        type: Array
    }
  },
  data () {
    return {
        swiperWrapperWidth: 0,
        firstEl: 0,
        left: 0,
        prevSplitWidth: 30,
        timer: undefined,
        hoverIndex: -1
    }
  },
  methods: {
    move(direction){
        if(direction == 'next'){
            if(Math.abs(this.left) + this.prevSplitWidth + 1360 <= this.$refs.swiperWrapper.scrollWidth){
                this.left += -this.$refs.historyItem[this.firstEl].clientWidth
                this.firstEl++
            }else{
                this.left = 0
                this.firstEl = 0
            }
        }else if(direction == 'prev'){
            if(this.left != 0){
                this.firstEl--
                this.left -= -this.$refs.historyItem[this.firstEl].clientWidth
            }
        }
    }
  },
  mounted(){
    let elList = this.$refs.historyItem
    // let lastEl = elList[elList.length-1]
    // let lastScreenWidth = this.prevSplitWidth
    // let width = 0
    // for(let i = elList.length-1; i>=0; i--){
    //     lastScreenWidth += elList[i].clientWidth
    //     console.log("width:",width)
    //     console.log("lastScreenWidth:",lastScreenWidth)
    //     if(lastScreenWidth > 1360){
    //         lastEl.style.width = lastEl.clientWidth + (1360 - width) + 'px'
    //         break
    //     }
    //     width = lastScreenWidth
    // }



    elList.forEach(item=>{
        this.swiperWrapperWidth += item.clientWidth
    })
    // console.log(this.swiperWrapperWidth)
    this.$refs.swiperWrapper.style.width = this.swiperWrapperWidth + this.prevSplitWidth + 1 + 'px'
    this.timer = setInterval(()=>{
        this.move('next')
    },3000)
  },
  destroyed(){
    clearInterval(this.timer)
  }
}
</script> 

<style lang='less' scoped>
    .historyBox-content{
        margin-top: 50px;
        height: 650px;
        background-image: url("../../assets/images/image163.png");
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center center;
        .prev,.next{
            width: 40px;
            height: 650px;
            float: left;
            display: flex;
            align-items: center;
            cursor: pointer;
            img{
                width: 18px;
                height: 35px;
            }
        }
        .next{
            justify-content: flex-end;
        }
        .swiper{
            width: 1360px;
            float: left;
            overflow: hidden;
            .swiper-wrapper{
                height: 650px;
                position: relative;
                transition: .5s all ease;
                .prev-split{
                    height: 2px;
                    border-top: 1px solid #333333;
                    border-bottom: 1px solid #333333;
                    float: left;
                    position: relative;
                    top: 50%;
                    transform: translateY(-50%);
                }
                .item{
                    position: relative;
                    float: left;
                    top: 50%;
                    transform: translateY(-15px);
                    .circle-outer{
                        height: 30px;
                        width: 30px;
                        border-radius: 50%;
                        border: 2px solid #333333;
                        box-sizing: border-box;
                        position: relative;
                        .circle-inner{
                            height: 14px;
                            width: 14px;
                            border-radius: 50%;
                            background-color: #DB0000;
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%,-50%);
                        }
                    }
                    .contentOdd{
                        transform: translateY(calc(-100% - 30px));
                        &::before{
                            top: calc(100% + 15px) !important;
                        }
                        padding-top: 0px !important;
                    }
                    .content{
                        height: 310px;
                        position: relative;
                        margin-left: 15px;
                        border-left: 1px solid #DB0000;
                        padding: 20px 8px 0px 10px;
                        box-sizing: border-box;
                        &::before{
                            content: "";
                            height: 2px;
                            width: calc(100% - 12px);
                            border-top: 1px solid #333333;
                            border-bottom: 1px solid #333333;
                            position: absolute;
                            left: 12px;
                            top: -15px;
                            transform: translateY(-50%);
                        }
                        .date{
                            height: 40px;
                            line-height: 40px;
                            width: 120px;
                            color: white;
                            background-color: #DB0000;
                            text-align: center;
                            font-size: 20px;
                            font-weight: bold;
                            margin-bottom: 10px;
                        }
                        .title{
                            font-size: 16px;
                            font-weight: bold;
                            white-space: nowrap;
                        }
                        .sub-title{
                            font-size: 14px;
                        }
                        .certification{
                            font-size: 14px;
                            margin-top: 26px;
                            .cerName{
                                margin-bottom: 10px;
                            }
                            .imgBox{
                                position: relative;
                                display: inline-block;
                                .cerImg{
                                    height: 100px;
                                }
                                .mask{
                                    cursor: pointer;
                                    pointer-events: none;
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                    background-color: rgba(0, 0, 0, .5);
                                    position:absolute;
                                    left: 0;
                                    top: 0;
                                    width: 100%; 
                                    height: 100px;
                                    z-index: 999;
                                    img{
                                        width: 45px;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
</style>
